export const residentTypeOptions = [
    { label: "Own", value: "Own" },
    { label: "Rent", value: "Rent" },
    { label: "Unknown", value: "Unknown" }
] as const



export const residenceTypeOptions = [
    { label: "Primary - Living in Home", value: "Primary - Living in Home" },
    { label: "Primary - Displaced", value: "Primary - Displaced" },
    { label: "Second Home", value: "Second Home" },
    { label: "Commercial (church, partner, etc)", value: "Commercial (church, partner, etc)" },
    { label: "Other", value: "Other" },
] as const

export const structureTypeOptions = [
    { label: "House", value: "House" },
    { label: "Duplex", value: "Duplex" },
    { label: "Mobile Home", value: "Mobile Home" },
    { label: "Apartment", value: "Apartment" },
    { label: "Condo", value: "Condo" },
    { label: "Other", value: "Other" },
] as const

export const canBeHomeRepairedOptions = [
    { label: "Yes, home is repairable", value: "Yes, home is repairable" },
    { label: "No, home is to be demolished", value: "No, home is to be demolished" },
    { label: "Unknown, assessment is needed", value: "Unknown, assessment is needed" },
] as const

export const isNewHousingHelpNeededOptions = [
    { label: "Yes, new mobile home", value: "Yes, new mobile home" },
    { label: "Yes, new site built home", value: "Yes, new site built home" },
    { label: "No", value: "No" },
    { label: "Unknown", value: "Unknown" },
] as const

export const isHomeRepairedOptions = [
    { label: "Yes, home is repairable", value: "Yes, home is repairable" },
    { label: "No, home is to be demolished", value: "No, home is to be demolished" },
    { label: "Unknown, assessment is needed", value: "Unknown, assessment is needed" },
    { label: "No Need, exterior work only", value: "No Need, exterior work only" },
] as const

export const buildingHeightOptions = [
    { label: "1 story", value: "1 story" },
    { label: "2 story", value: "2 story" },
    { label: "3 story", value: "3 story" },
] as const

export const potentialStructuralProblemsOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
    { label: "Unknown", value: "Unknown" },
] as const

export const heightOfWaterOptions = [
    { label: "none", value: "none" },
    { label: "0-6 in", value: "0-6 in" },
    { label: "6-12 in", value: "6-12 in" },
    { label: "12 in - 2 ft", value: "12 in - 2 ft" },
    { label: "2-4 ft", value: "2-4 ft" },
    { label: "over 4 ft", value: "over 4 ft" },
] as const

export const assessmentCompletedOptions = [
    { label: "No Assistance Required", value: "No Assistance Required" },
    { label: "Needed Not Started", value: "Needed Not Started" },
    { label: "Reassessment Needed", value: "Reassessment Needed" },
    { label: "Complete", value: "Complete" },
] as const

export const workScopeStatusOptions = [
    { label: "Unknown", value: "Unknown" },
    { label: "No Assistance Required", value: "No Assistance Required" },
    { label: "Needed Not Started", value: "Needed Not Started" },
    { label: "Materials Only", value: "Materials Only" },
    { label: "Materials Only Complete", value: "Materials Only Complete" },
    { label: "25%", value: "25%" },
    { label: "50%", value: "50%" },
    { label: "75%", value: "75%" },
    { label: "Complete", value: "Complete" },
] as const

export const kindOfRoofWorkOptions = [
    { label: "Tear off and replace", value: "Tear off and replace" },
    { label: "Partial Replacement", value: "Partial Replacement" },
    { label: "Patch", value: "Patch" },
] as const

export const roofPitchOptions = [
    { label: "Flat", value: "Flat" },
    { label: "Shallow (walkable)", value: "Shallow (walkable)" },
    { label: "Steep", value: "Steep" },
] as const



export const interiorWallMaterialsOptions = [
    { label: "Drywall", value: "Drywall" },
    { label: "Paneling", value: "Paneling" },
    { label: "Other", value: "Other" },
] as const

export const whatTypeOfFlooringOptions = [
    { label: "Concrete", value: "Concrete" },
    { label: "Wood", value: "Wood" },
] as const

export const buildingInspectionStatusOptions = [
    { label: "Needed", value: "Needed" },
    { label: "Cancelled", value: "Cancelled" },
    { label: "Partial", value: "Partial" },
    { label: "Pass", value: "Pass" },
] as const

export const ownerBuilderPermitStatusOptions = [
    { label: "Not Needed", value: "Not Needed" },
    { label: "Owner Builder Permit Issued", value: "Owner Builder Permit Issued" },
    { label: "Building Permit Withdrawn", value: "Building Permit Withdrawn" },
    { label: "Building Permit Closed", value: "Building Permit Closed" },
] as const

export const overallStatusOptions = [
    { label: "No Assistance Required", value: "No Assistance Required" },
    { label: "Not Started", value: "Not Started" },
    { label: "In Progress", value: "In Progress" },
    { label: "Materials Only", value: "Materials Only" },
    { label: "Materials Only Complete", value: "Materials Only Complete" },
    { label: "Functionally Complete", value: "Functionally Complete" },
    { label: "Complete", value: "Complete" },
    { label: "100%", value: "100%" },
    { label: "HOR", value: "HOR" },
    { label: "Demo", value: "Demo" },
] as const

// UI dropdowns should not expose legacy status options.
export const overallStatusSelectableOptions = overallStatusOptions.filter(
    (option) => option.value !== "100%"
)

export const goodwillStatusOptions = [
    { label: "Not Started", value: "Not Started" },
    { label: "In Progress", value: "In Progress" },
    { label: "Unknown", value: "Unknown" },
    { label: "Complete", value: "Complete" },
    { label: "No Assistance Required", value: "No Assistance Required" },
] as const